export default {
    isLoggedIn: false,
    userDetails: {}
};
